import BackgroundImage from './BackgroundImage';
import Checkbox from './Checkbox';
import Icon from './Icon';
import SiteButton from './SiteButton';
import { Link, File, Placeholder, Image } from '@sitecore-jss/sitecore-jss-vue';
import SiteRichText from './SiteRichText';
import SiteText from './SiteText';
import SiteLink from './SiteLink';
import Modal from './Modal';
import FormTextarea from './FormTextarea';
import Dropdown from './Dropdown';
import DropDownMultiple from './DropDownMultiple';
import AdaptiveImage from './AdaptiveImage';
import AdaptiveMedia from './AdaptiveMedia';
import FlippedNumber from './FlippedNumber';
import GoogleRecaptcha from './GoogleRecaptcha';
import GeeCaptcha from './GeeCaptcha';
import CaptchaInput from './CaptchaInput';
import SiteImage from './SiteImage';
import VideoPlayer from './VideoPlayer.vue';
import ContentGrid from './ContentGrid';
export default {
  install(Vue) {
    Vue.component('ContentGrid', ContentGrid);
    Vue.component('BackgroundImage', BackgroundImage);
    Vue.component('Checkbox', Checkbox);
    Vue.component('JssLink', Link);
    Vue.component('JssText', SiteText);
    Vue.component('JssRichText', SiteRichText);
    Vue.component('JssFile', File);
    Vue.component('JssImage', Image);
    Vue.component('Placeholder', Placeholder);
    Vue.component('Icon', Icon);
    Vue.component('SiteButton', SiteButton);
    Vue.component('SiteLink', SiteLink);
    Vue.component('Modal', Modal);
    Vue.component('FormTextarea', FormTextarea);
    Vue.component('Dropdown', Dropdown);
    Vue.component('VideoPlayer', VideoPlayer);
    Vue.component('DropDownMultiple', DropDownMultiple);
    Vue.component('AdaptiveImage', AdaptiveImage);
    Vue.component('AdaptiveMedia', AdaptiveMedia);
    Vue.component('FlippedNumber', FlippedNumber);
    Vue.component('SiteImage', SiteImage);
    Vue.component('GoogleRecaptcha', GoogleRecaptcha);
    Vue.component('GeeCaptcha', GeeCaptcha);
    Vue.component('CaptchaInput', CaptchaInput);
  },
};
